import moment from 'utils/moment';
import { useMemo, useState } from 'react';
import aptActions from 'services/actions/apt';
import aptSelectors from 'services/selectors/apt';
import { IApiHistoryCallerIdParams } from 'services/types/caller';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { ICustomerUI, IUICallerIdHistoryItem } from 'types/customer';
import { formatPhone } from 'utils/formatPhone';
import uuid from 'utils/uuid';
import caller_id_icon from './caller-id-icon.svg';
import CallerIdHistoryModal, { callerIdHistoryModalRef } from './CallerIdHistoryModal';

const DATE_FORMAT = 'MM-DD-YYYY';

const CallerIdHistory = () => {
  const [open, setOpen] = useState<string>('');
  const dispatch = useAppDispatch();
  const params = aptSelectors.callerId.params();
  const loading = aptSelectors.callerId.loading();
  const callerIdData = aptSelectors.callerId.data();
  const totalItems = callerIdData?.total || 0;
  const [customer, setCustomer] = useState<ICustomerUI | null>(null);
  const dataSource = useMemo(() => (callerIdData?.data?.map(o => ({
    name: o.customerName || 'Unknown Customer',
    phone: o.customerPhone ? formatPhone(o.customerPhone) : '--',
    customerType: o.customerType?.toLowerCase() === 'regular' ? 'regular' : 'new',
    id: o.id || uuid(),
    date: o.date || 'Unknown Date',
    time: o.time || 'Unknown Time',
    booked: o.booked,
    customerId: o.customerId,
    sentSms: o.sentSms,
  })) || []) as IUICallerIdHistoryItem[], [callerIdData?.data]);

  const fetchData = async (_params: IApiHistoryCallerIdParams) => {
    dispatch(aptActions.getCallerIdHistory.fetch(_params));
    dispatch(aptActions.getAppointmentSummaryCallerId.fetch(_params));
  };

  const onFilter = (_params: Partial<IApiHistoryCallerIdParams>) => {
    const newParams: IApiHistoryCallerIdParams = {
      endDate: _params?.endDate || moment().format(DATE_FORMAT),
      startDate: _params.startDate || moment().format(DATE_FORMAT),
      page: 1,
    };
    fetchData(newParams);
  };

  const onOpen = async () => {
    setOpen(uuid());
    const _params: IApiHistoryCallerIdParams = {
      startDate: moment().format(DATE_FORMAT),
      endDate: moment().format(DATE_FORMAT),
      page: 1,
    };
    fetchData(_params);
  };

  const onClose = () => {
    setOpen('');
  };

  const onChangePage = (page: number) => {
    const newParams: IApiHistoryCallerIdParams = {
      ...params,
      page,
    };
    fetchData(newParams);
  };

  const onSelectCustomer = (o: ICustomerUI | null) => {
    setCustomer(o);
    const newParams: IApiHistoryCallerIdParams = {
      ...params,
      keySearch: (o?.phone || '').replace(/[^0-9]/g, ''),
    };
    if (!o) {
      delete newParams.keySearch;
    }
    fetchData(newParams);
  };

  return (
    <>
      <ButtonCaller type='button' onClick={onOpen}>
        <img src={caller_id_icon} alt="caller_id_icon" style={{ width: 32, height: 32 }} />
        <span>Caller ID</span>
      </ButtonCaller>
      <CallerIdHistoryModal key={open} ref={callerIdHistoryModalRef} visible={!!open} onClose={onClose}
        dataSource={dataSource}
        params={params}
        onChange={onFilter}
        loading={loading}
        totalItems={totalItems}
        onChangePage={onChangePage}
        customer={customer}
        onSelectCustomer={onSelectCustomer}
      />
    </>
  );
};

export default CallerIdHistory;

const ButtonCaller = styled.button`
display: flex;
height: 48px;
padding: 0 16px;
margin-left: 8px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 4px;
background: #F05326;

&:hover {
  cursor: pointer;
}
&:active {
  opacity: 0.5;
}

span {
  color: #FFF;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
`;
